import { bodyBgType } from './BodyBgStore';

export const updateBodyBgType = (value) => bodyBgType.update(oldValue => value);
